import * as React from 'react';
import {Line} from 'react-chartjs-2';
import {Col, Row, Typography} from 'antd';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend, ChartOptions,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);


const {Title} = Typography;

interface ComponentProps {
  coinHistory: any;
  currentPrice: string;
  coinName: string;
}

const LineChart: React.FC<ComponentProps> = ({coinHistory, currentPrice, coinName}) => {


  const coinPrice: any[] = [];
  const coinTimestamp: string[] = [];

  coinHistory?.data?.history.forEach((element: any) => {
    coinPrice.push(element.price);
    coinTimestamp.push(new Date(element.timestamp * 1000).toLocaleDateString());
  });

  const data = {
    labels: coinTimestamp.reverse(),
    datasets: [
      {
        label: 'Price In USD',
        data: coinPrice.reverse(),
        fill: false,
        backgroundColor: '#0071bd',
        borderColor: '#0071bd',
      },
    ],
  };

  const options: ChartOptions<any> = {
    responsive: true,
    interaction: {
      mode: 'index' as const,
      intersect: false,
    },
    plugins: {
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Crypto Value",
      },
    },
    stacked: false,
    scales: {
      y: {
        beginAtZero: false,
      },
    },
  };

  return (
    <>
      <Row className="chart-header">
        <Title level={2} className="chart-title">{coinName} Price Chart </Title>
        <Col className="price-container">
          <Title level={5} className="price-change">Change: {coinHistory?.data?.change}%</Title>
          <Title level={5} className="current-price">Current {coinName} Price: $ {currentPrice}</Title>
        </Col>
      </Row>

      <Line data={data} options={options}/>
    </>
  )
};

export default React.memo<ComponentProps>(LineChart);